import { render } from "./RiTutorial01.vue?vue&type=template&id=cf448c28"
import script from "./RiTutorial01.vue?vue&type=script&lang=js"
export * from "./RiTutorial01.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiTutorial01.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf448c28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf448c28', __exports__)) {
    api.reload('cf448c28', __exports__)
  }
  
  module.hot.accept("./RiTutorial01.vue?vue&type=template&id=cf448c28", () => {
    api.rerender('cf448c28', render)
  })

}


export default __exports__